<template>
    <div>
        <div class="tour" :style="karteListeStyle">
            <Breadcrumb />

            <div class="left-sidebar hide-on-mobile">
                <div class="panel-header ml50">
                    <div class="page-title">
                        <h5>KulTouren</h5>
                        <p>Kieler Quartiere entdecken</p>
                    </div>

                    <button @click="showFilter = !showFilter"
                        class="btn btn-fill icon-after float-right btn-focus-design"
                        aria-label="Weitere Filter anzeigen">
                        Filter
                        <i class="material-icons" aria-hidden="true">{{ !showFilter ? 'keyboard_arrow_down' :
                            'keyboard_arrow_up' }}</i>
                    </button>
                </div>

                <div class="filter-section-wrapper">
                    <div class="filter-section mt20" v-show="showFilter">

                        <touren-filter v-if="contentType !== null" :contentType="contentType"
                            :selectedFilters="selectedFilters" :structuredFilters="structuredFilters"
                            @filterChanged="filtersChanged" @resetAllFilters="resetAllFilters" />

                    </div>

                    <div class="row card-sections">
                        <div class="col-12" v-for="(item, index) in kultourDataSet.data" :key="index"
                            :id="'kultour-' + item.id" :data-kultour-id="item.id"
                            @click.capture="rememberLastVisited(item.id)">
                            <CardKultour v-if="kultourDataSet.total >= 1" :collection="item"
                                :id="'vertical-collection-' + kultourDataSet.data.id" :isSmall="false"
                                :marginBottom="'15px'" :disableLink="true" @highlight="highlightThisContent"
                                @click.native="rememberLastVisited(item.id)" />
                        </div>
                        <div class="no-kultour" v-if="kultourDataSet.data < 1">
                            <div class="container-fluid blank">
                                <div class="blank-section">
                                    <img src="/assets/blank-image.png" alt="Blank">
                                    <h4 class="mt20">Keine KulTouren gefunden.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="map-section">
                <the-map ref="theMap" v-if="active === SECTIONS.KARTE && kultourDataSet.data != null"
                    :collections="kultourDataSet.data" @highlight="highlightThisContent"
                    @remember-last-visited="rememberLastVisited"></the-map>
                <div class="only-on-mobile mt30">
                    <!-- Mobile Filter Button -->
                    <div class="mobile-filter-button-wrapper">
                        <button class="btn btn-filter-mobile" @click="showMobileFilter = !showMobileFilter"
                            :aria-label="showMobileFilter ? 'Filter schließen' : 'Filter anzeigen'"
                            :aria-expanded="showMobileFilter">
                            <span>Filter</span>
                            <i class="material-icons" aria-hidden="true">{{ showMobileFilter ? 'keyboard_arrow_down' :
                                'keyboard_arrow_up' }}</i>
                        </button>
                    </div>

                    <!-- Mobile Filter Overlay Backdrop -->
                    <div v-if="showMobileFilter" class="mobile-filter-backdrop" @click="showMobileFilter = false"
                        @touchstart.prevent="handleBackdropTouch" @touchmove.prevent
                        @touchend.prevent="showMobileFilter = false">
                    </div>

                    <!-- Mobile Filter Content -->
                    <div v-if="showMobileFilter" class="mobile-filter-content" @touchstart.stop @touchmove.stop>
                        <div class="mobile-filter-header">
                            <h5>Filter</h5>
                            <button class="btn btn-link btn-icon-close" @click="showMobileFilter = false"
                                aria-label="Filter schließen">
                                <i class="material-icons" aria-hidden="true">close</i>
                            </button>
                        </div>
                        <div class="mobile-filter-body">
                            <touren-filter v-if="contentType !== null" :contentType="contentType"
                                :selectedFilters="selectedFilters" :structuredFilters="structuredFilters"
                                @filterChanged="handleMobileFilterChanged"
                                @resetAllFilters="handleMobileResetFilters" />
                        </div>
                    </div>

                    <div class="btn-custom btn-list-map-switch" :class="{ 'filter-open': showMobileFilter }">
                        <button :class="['btn btn-custom__item', active === SECTIONS.KARTE ? 'active' : '']"
                            @click="active = SECTIONS.KARTE">Karte</button>
                        <button :class="['btn btn-custom__item', active === SECTIONS.LISTE ? 'active' : '']"
                            @click="active = SECTIONS.LISTE">Liste</button>
                    </div>
                    <div v-if="active === SECTIONS.KARTE" class="scroll-container horizontal-scroll">
                        <div v-for="(item, index) in kultourDataSet.data" :key="index" class="horizontal-scroll-card"
                            :id="'kultour-' + item.id" :data-kultour-id="item.id"
                            @click.capture="rememberLastVisited(item.id)">
                            <CardKultour v-if="kultourDataSet.total >= 1" :id="'horizontal-collection-' + item.id"
                                :collection="item" :isSmall="true"
                                :marginBottom="active === SECTIONS.KARTE ? '0' : '20px'"
                                :marginRight="active === SECTIONS.LISTE ? '0' : '20px'" :disableLink="true"
                                @highlight="highlightThisContent" class="map-card"
                                @click.native="rememberLastVisited(item.id)" />
                        </div>
                    </div>

                    <div v-if="active === SECTIONS.LISTE" class="list-container">
                        <div v-for="(item, index) in kultourDataSet.data" :key="index" class="horizontal-scroll-card"
                            :id="'kultour-' + item.id" :data-kultour-id="item.id"
                            @click.capture="rememberLastVisited(item.id)">
                            <CardKultour v-if="kultourDataSet.total >= 1" :id="'horizontal-collection-' + item.id"
                                :collection="item" :isSmall="true"
                                :marginBottom="active === SECTIONS.KARTE ? '0' : '20px'"
                                :marginRight="active === SECTIONS.LISTE ? '0' : '20px'"
                                @highlight="highlightThisContent" class="list-card"
                                @click.native="rememberLastVisited(item.id)" />
                        </div>
                    </div>
                </div>

            </div>
        </div>



        <div class="footer-margin hide-on-mobile">
        </div>
    </div>
</template>

<script>
import { search } from '@/api/content';
import { getCtype } from '@/api/contentType';
import { showLoader, hideLoader, getStructuredFilters, isset } from '@/utils/betterHelpers';
import { buildFilterSignatureFromQuery, saveLastVisitedItem, loadLastVisitedItem } from '@/utils/helpers';
import { isMobile } from 'mobile-device-detect';
import VueScrollTo from 'vue-scrollto';

const SECTIONS = Object.freeze({
    KARTE: 'KARTE',
    LISTE: 'LISTE'
});

export default {
    name: 'KulTouren',
    components: {
        CardKultour: () => import('@/components/cards/CardKultour.vue'),
        FilterBox: () => import('./components/filterBox.vue'),
        Breadcrumb: () => import('@/components/controls/Breadcrumb.vue'),
        TheMap: () => import('./components/tourenIndexMap.vue'),
        TourenFilter: () => import('@/components/filters/kultouren.vue'),
    },
    data() {
        return {
            loader: null,
            contentType: null,
            currentContentTypeId: this.$kultourId,
            selectedFilters: new Map(),
            expandFilter: false,
            kultourDataSet: {
                total: 0,
                data: null,
                meta: null,
                query: {
                    page: 1,
                    limit: 1000,
                    type: 'view',
                    view_status: 1,
                    resourceType: 'view',
                    selectedContentTypeId: this.$kultourId,
                    keyword: '',
                    sort: {
                        prop: 'title',
                        order: 'ascending'
                    },
                },
            },
            isItMobile: isMobile ? true : false,
            showFilter: false,
            showMobileFilter: false,
            _savedScrollPosition: null,
            SECTIONS,
            active: SECTIONS.KARTE,
            scrollVerticalOptions: {
                container: '.card-sections',
                easing: 'ease-in',
                lazy: false,
                offset: -60,
                force: true,
                cancelable: true,
                x: false,
                y: true,
            },
            scrollHorizontalOptions: {
                container: '.horizontal-scroll',
                easing: 'ease-in',
                lazy: false,
                offset: -60,
                force: true,
                cancelable: true,
                x: true,
                y: false,
            },
        }
    },
    computed: {
        karteListeStyle() {
            if (this.active === SECTIONS.KARTE)
                return "height: 100vh !important;"
            else {
                return "height: auto !important;margin-bottom:152px;"
            }
        },
        structuredFilters() {
            return getStructuredFilters(this.contentType);
        },
        allFilters() {
            return this.structuredFilters;
        },
        uriFilters() {
            return this.$route.query.filters;
        },
    },
    beforeDestroy() {
        // Clean up body class when component is destroyed
        if (this.showMobileFilter) {
            document.body.classList.remove('filter-open');
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            if (this._savedScrollPosition) {
                window.scrollTo(0, this._savedScrollPosition);
            }
        }
    },
    watch: {
        showMobileFilter(newVal) {
            // Lock body scroll when filter is open (Safari iOS fix)
            if (newVal) {
                const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
                document.body.classList.add('filter-open');
                // Prevent iOS bounce scrolling
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
                document.body.style.top = `-${scrollY}px`;
                // Store scroll position for restoration
                this._savedScrollPosition = scrollY;
            } else {
                const scrollY = this._savedScrollPosition || 0;
                document.body.classList.remove('filter-open');
                document.body.style.position = '';
                document.body.style.width = '';
                document.body.style.top = '';
                // Restore scroll position
                if (scrollY > 0) {
                    window.scrollTo(0, scrollY);
                }
                this._savedScrollPosition = null;
            }
        }
    },
    created() {
        this.selectedFilters = new Map();
        this.getContentType();
        this.initializeFromUrl();
    },
    methods: {
        showLoader,
        hideLoader,
        isset,
        getStructuredFilters,
        async getKultourenList() {
            this.loader = this.showLoader(this.loader);
            const { limit, page } = this.kultourDataSet.query;
            const { data, meta } = await search(this.kultourDataSet.query);
            this.kultourDataSet.data = data;
            data.forEach((element, index) => {
                element['index'] = (page - 1) * limit + index + 1;
            });

            this.kultourDataSet.meta = meta;
            this.kultourDataSet.total = meta.total;
            this.loader = this.hideLoader(this.loader);

            // Scroll to last visited item if present
            this.$nextTick(() => {
                try {
                    const signature = this.getCurrentFilterSignature();
                    const lastId = loadLastVisitedItem(this.$route.path, signature);
                    if (lastId && typeof lastId === 'number') {
                        let attempts = 0;
                        const maxAttempts = 50;
                        const tryScroll = () => {
                            attempts++;

                            if (this.isItMobile) {
                                // Mobile: try horizontal scroll first (map mode), then list mode
                                if (this.active === SECTIONS.KARTE) {
                                    const target = '#horizontal-collection-' + lastId;
                                    const elem = document.querySelector(target);
                                    if (elem) {
                                        VueScrollTo.scrollTo(target, '800', this.scrollHorizontalOptions);
                                        return;
                                    }
                                } else if (this.active === SECTIONS.LISTE) {
                                    const target = `[data-kultour-id="${lastId}"]`;
                                    const elem = document.querySelector(target);
                                    if (elem) {
                                        elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        return;
                                    }
                                }
                            } else {
                                // Desktop: try vertical collection first, then fallback to wrapper
                                const verticalTarget = '#vertical-collection-' + lastId;
                                const verticalElem = document.querySelector(verticalTarget);
                                if (verticalElem) {
                                    VueScrollTo.scrollTo(verticalTarget, '800', this.scrollVerticalOptions);
                                    return;
                                }

                                // Fallback to wrapper
                                const wrapperTarget = `#kultour-${lastId}`;
                                const wrapperElem = document.querySelector(wrapperTarget);
                                if (wrapperElem) {
                                    wrapperElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    return;
                                }
                            }

                            // If element not found and we haven't exceeded max attempts, try again
                            if (attempts < maxAttempts) {
                                setTimeout(tryScroll, 200);
                            }
                        };
                        tryScroll();
                    }
                } catch (e) { /* no-op */ }
            });
        },
        resetAllFilters() {
            this.selectedFilters = new Map();
            this.kultourDataSet.query.keyword = '';
            this.filtersChanged(this.selectedFilters);

            // Clear URL parameters
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    filters: undefined,
                    page: undefined,
                    q: undefined
                }
            });
        },
        getContentType() {
            this.contentType = null;
            var id = this.currentContentTypeId;
            this.selectedFilters = new Map();
            getCtype(id).then(response => {
                this.contentType = response.data;
                this.initializeFromUrl();
            });
        },
        filtersChanged(selectedFilters) {
            this.selectedFilters = selectedFilters;
            this.kultourDataSet.query.page = 1;
            this.kultourDataSet.query.filters = JSON.stringify(Array.from(selectedFilters.entries()));

            this.updateUrl();

            this.getKultourenList();
        },
        updateUrl() {
            const filterParams = Array.from(this.selectedFilters)
                .map(([key, values]) => `${key}:${values.join(',')}`)
                .join(',');

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    filters: filterParams || undefined,
                    page: this.kultourDataSet.query.page > 1 ? this.kultourDataSet.query.page : undefined,
                    q: this.kultourDataSet.query.keyword || undefined
                }
            });
        },
        initializeFromUrl() {
            // Only initialize if content type is loaded
            if (!this.contentType) return;

            const query = this.$route.query;

            // Initialize filters from URL
            if (query.filters) {
                this.applyFiltersFromUrl(query.filters);
                // Show filters if there are any in the URL
                this.showFilter = true;
                // Don't auto-open mobile filter on load, let user decide
            }

            // Initialize page from URL
            if (query.page) {
                const page = parseInt(query.page) || 1;
                this.kultourDataSet.query.page = page;
            }

            // Initialize search term from URL
            if (query.q) {
                this.kultourDataSet.query.keyword = decodeURIComponent(query.q);
            }

            // Fetch data with URL parameters
            this.getKultourenList();
        },
        applyFiltersFromUrl(filtersParam) {
            if (!filtersParam) {
                this.selectedFilters = new Map();
                return;
            }

            try {
                const decodedFilters = decodeURIComponent(filtersParam);
                const filterMap = new Map();

                const filterPairs = decodedFilters.split(/,(?=\d+:)/);

                filterPairs.forEach(pair => {
                    const [key, ...valuesParts] = pair.split(':');
                    if (key) {
                        const values = valuesParts.join(':');
                        const valueArray = values.split(',')
                            .map(v => v.trim())
                            .filter(v => v);

                        if (valueArray.length > 0) {
                            filterMap.set(Number(key), valueArray);
                        }
                    }
                });

                this.selectedFilters = filterMap;
                this.kultourDataSet.query.filters = JSON.stringify(Array.from(filterMap.entries()));
            } catch (error) {
                console.error('Error parsing filters from URL:', error);
                this.selectedFilters = new Map();
            }
        },
        highlightThisContent(params) {
            Object.keys(this.kultourDataSet.data).forEach((k) => {
                this.kultourDataSet.data[k].highlight = false;
                if (this.kultourDataSet.data[k].id == params.collection.id) {
                    this.kultourDataSet.data[k].highlight = true;

                    if (params.sender != "map") {
                        this.$refs.theMap.openPopup(params.collection);
                    }
                    else {
                        if (this.isItMobile) {
                            VueScrollTo.scrollTo(('#horizontal-collection-' + this.kultourDataSet.data[k].id), '2000', this.scrollHorizontalOptions);
                        }
                        else {
                            VueScrollTo.scrollTo(('#vertical-collection-' + this.kultourDataSet.data[k].id), '2000', this.scrollVerticalOptions);
                        }
                    }
                }
            });
        },
        getCurrentFilterSignature() {
            const q = this.$route.query || {};
            const qp = {};
            if (q.filters) qp.filters = q.filters;
            if (q.page) qp.page = q.page;
            if (q.q) qp.q = q.q;
            return buildFilterSignatureFromQuery(qp);
        },
        rememberLastVisited(id) {
            try {
                const signature = this.getCurrentFilterSignature();
                saveLastVisitedItem(this.$route.path, signature, id);
            } catch (e) { /* no-op */ }
        },
        openMobileFilters() {
            // Mobile filter handler - toggle filter visibility on mobile
            this.showMobileFilter = !this.showMobileFilter;
        },
        handleMobileFilterChanged(selectedFilters) {
            this.filtersChanged(selectedFilters);
            // Auto-close filter after selection on mobile for better UX
            this.$nextTick(() => {
                this.showMobileFilter = false;
            });
        },
        handleMobileResetFilters() {
            this.resetAllFilters();
            // Keep filter open after reset so user can select new filters
        },
        handleBackdropTouch(e) {
            // Prevent backdrop touch from scrolling on Safari iOS
            e.preventDefault();
            this.showMobileFilter = false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.no-kultour {

    .container-fluid {
        max-width: 250px;
        margin: 0 auto;
        text-align: center;
    }

    .blank {
        display: flex;
        align-items: center;
        height: 80vh;
    }
}

.filter-section {
    margin-bottom: 30px;
}

.tour {
    position: relative;
    padding-top: 70px;
    display: flex;
    height: 100vh;
    overflow: hidden;
    z-index: 0;
    background: transparent;

    @media(max-width: 786px) {
        height: 100vh;
    }

    @media (max-width: 350px) {
        padding-top: 60px;
    }

    .left-sidebar {
        flex: 0 450px;
        background: #fff;
        margin-top: 35px;

        @media (max-width: 991px) {
            flex: 0 350px;
        }

        .panel-header {
            display: flex;
            justify-content: space-between;
            margin-left: 70px !important;
            margin-right: 40px;


            @media (min-width: 1200px) {
                margin-left: 90px !important;
            }

            .page-title {
                h5 {
                    margin-bottom: 10px;
                }
            }

            h5,
            p {
                margin-bottom: 0;
                line-height: 0.8em;
            }

            div {
                flex: 1;
            }

            button {
                flex: 0 10px;
                max-height: 40px;
            }
        }

        .filter-section-wrapper {
            max-height: calc(100vh - 150px);
            overflow-y: auto;
            padding-right: 10px;
            padding: 20px 20px 0px 40px;

            &::-webkit-scrollbar {
                width: 10px;
                padding: 2px;
            }

            &::-webkit-scrollbar-track {
                padding: 2px;
                background-color: rgba($color: #c4c4c4, $alpha: 0.4);
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                box-shadow: inset 0 0 6px rgba($color: #a4a4a4, $alpha: 0.8);
                background-color: rgba($color: #c4c4c4, $alpha: 0.8);
                border: 2px solid rgba($color: #c4c4c4, $alpha: 0.4);
            }
        }

        .card-sections {
            margin-right: 0px;
            overflow: hidden;
            overflow-y: auto;
            margin-top: 20px;

            &::-webkit-scrollbar-track {
                padding: 2px;
                margin-bottom: 20px;
                background-color: rgba($color: #c4c4c4, $alpha: 0.4)
            }

            &::-webkit-scrollbar {
                width: 10px;
                padding: 2px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                box-shadow: inset 0 0 6px rgba($color: #a4a4a4, $alpha: 0.8);
                background-color: rgba($color: #c4c4c4, $alpha: 0.8);
                border: 2px solid rgba($color: #c4c4c4, $alpha: 0.4);
            }
        }
    }

    .map-section {
        flex: 1;
        background: #fff;

        img {
            position: absolute;
            height: 100%;
        }

        .scroll-container {
            position: absolute;
            top: 55vh;
            z-index: 1001;
            width: 100vw;

            @media (max-width: 786px) {
                top: auto;
                bottom: 10px;
                // Ensure horizontal scroll cards don't overlap with filter button
                padding-bottom: 110px;
            }

            .horizontal-scroll-card {
                margin-right: 15px;
            }

        }

        .list-container {
            position: relative;
            top: 50px;
            max-width: 500px;
            margin: 0 auto;
            margin-bottom: 200px;
            padding: 0 15px;

            .list-card {
                @media(max-width:992px) {
                    min-height: 175px;
                }
            }
        }

        .btn-custom {
            position: relative;
            display: block;
            width: 200px;
            margin: 0 auto;
            top: 22px;
            border-radius: 30px;
            box-shadow: -5px 5px 15px 0px rgba($color: $primary, $alpha: 0.2);


            &.btn-list-map-switch {
                z-index: 1001;
                position: absolute;
                top: 110px;
                left: 50%;
                transform: translate(-50%, -50%);

                @media (max-width: 786px) {
                    // Ensure toggle is visible above scroll container (z-index 1001) and map
                    z-index: 1003;
                    position: fixed;
                }
            }

            &__item {
                padding: 10px 25px;
                border: 0;
                width: 100px;
                background: #fff;
                font-size: 16px;
                font-family: 'elliot-regular';
                font-weight: 400;
                text-transform: capitalize;
                color: $darkGray;
                border-radius: 0;

                &:first-child {
                    border-top-left-radius: 30px;
                    border-bottom-left-radius: 30px;
                }

                &:last-child {
                    border-top-right-radius: 30px;
                    border-bottom-right-radius: 30px;
                }

                &.active {
                    background: $infoColor;
                    font-weight: 700;
                    color: #fff;
                }
            }
        }
    }
}

.map-card {
    @media(max-width:991px) {
        height: 100%;
        min-width: 350px;
    }
}

// Mobile Filter Styles
.mobile-filter-button-wrapper {
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1002;
    width: 100%;
    max-width: 200px;
    pointer-events: none;

    .btn-filter-mobile {
        width: 100%;
        height: 44px;
        background: $infoColor;
        color: #fff;
        border: none;
        border-radius: 30px;
        box-shadow: 0px 5px 15px 0px rgba($color: $primary, $alpha: 0.3);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 600;
        font-family: 'elliot-regular', sans-serif;
        cursor: pointer;
        pointer-events: all;
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
        padding: 0 20px;
        transition: background-color 0.2s ease, box-shadow 0.2s ease;

        // Override global .btn .material-icons absolute positioning
        .material-icons {
            position: relative !important;
            top: auto !important;
            left: auto !important;
            right: auto !important;
            font-size: 20px;
            transition: transform 0.3s ease;
        }

        span {
            display: inline-block;
        }

        &:active {
            background: darken($infoColor, 10%);
            box-shadow: 0px 3px 10px 0px rgba($color: $primary, $alpha: 0.2);
        }

        &[aria-expanded="true"] .material-icons {
            transform: rotate(180deg);
        }
    }
}

.mobile-filter-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2100;
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    touch-action: none;
    -webkit-tap-highlight-color: transparent;
    // Safari iOS specific fixes
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
}

.mobile-filter-content {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    box-shadow: 0px -5px 20px 0px rgba($color: $primary, $alpha: 0.3);
    z-index: 2101;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    // Safari iOS specific fixes
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    // Prevent iOS bounce effect
    touch-action: pan-y;
    // Use safe-area-inset for iPhone X and newer
    padding-bottom: env(safe-area-inset-bottom);
    max-height: calc(85vh - env(safe-area-inset-bottom));

    .mobile-filter-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 20px 15px 20px;
        border-bottom: 1px solid rgba($color: #c4c4c4, $alpha: 0.3);
        flex-shrink: 0;

        h5 {
            margin: 0;
            font-size: 18px;
            font-weight: 700;
            color: $darkGray;
            font-family: 'elliot-bold', sans-serif;
        }

        .btn-icon-close {
            padding: 8px;
            min-width: auto;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: transparent;
            color: $darkGray;
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;

            &:active {
                background: rgba($color: #c4c4c4, $alpha: 0.2);
            }

            .material-icons {
                font-size: 24px;
            }
        }
    }

    .mobile-filter-body {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 20px;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;

        // Custom scrollbar for better visibility
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: rgba($color: #c4c4c4, $alpha: 0.2);
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba($color: #c4c4c4, $alpha: 0.6);
            border-radius: 3px;

            &:active {
                background: rgba($color: #c4c4c4, $alpha: 0.8);
            }
        }
    }
}

// Adjust map/list toggle position when filter button is visible
@media (max-width: 786px) {
    .btn-list-map-switch {
        // Keep original top positioning but ensure it's visible above scroll container
        top: 110px !important;
        bottom: auto !important;
        transform: translate(-50%, -50%) !important;
        z-index: 1003 !important; // Above scroll container (1001) but below filter button (1002)
        position: fixed !important;
        transition: opacity 0.2s ease, visibility 0.2s ease;

        // When filter is open, hide the toggle buttons to avoid overlap
        &.filter-open {
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
        }
    }
}

// Prevent body scroll when filter is open (Safari iOS fix)
@media (max-width: 786px) {
    body.filter-open {
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: hidden;
        // Prevent iOS bounce
        overscroll-behavior: none;
        -webkit-overflow-scrolling: touch;
    }
}
</style>